(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-card/assets/javascripts/casino-game-card.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-card/assets/javascripts/casino-game-card.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const CasinoGamePreviewSimple = svs.components.casino_react.casinoGamePreviewSimple.CasinoGamePreviewSimple;
const Image = svs.content.image_v2.Image;
const CasinoGameCardBadge = svs.components.casino_react.casinoGameCard.CasinoGameCardBadge;
const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState,
  memo = _React.memo;
const CasinoCardFallback = svs.components.casino_react.casinoCardFallback;
const urlMapping = svs.core.urlMapping;
const Button = svs.ui.ReactButton;
const _svs$components$casin = svs.components.casino_react,
  CasinoQuickInfo = _svs$components$casin.CasinoQuickInfo,
  CasinoCardWrapper = _svs$components$casin.CasinoCardWrapper;
const CasinoGamePreview = svs.components.casino_react.casinoGamePreview.CasinoGamePreview;
const Card = svs.ui.ReactCard.Card;
const _svs$components$casin2 = svs.components.casino_react.casino_game_live_info,
  CasinoGameBottomInformation = _svs$components$casin2.CasinoGameBottomInformation,
  CasinoGameRouletteBalls = _svs$components$casin2.CasinoGameRouletteBalls;
const brand = svs.casino_react.shared.data.brand;
const useLiveData = svs.components.casino_react.casino_store.hooks.useLiveData;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG;
const ImageMemoized = memo(Image);
const getFallbackImage = () => {
  let image = 'fallback-img-casino.jpg';
  if (brand === 'momang') {
    image = 'fallback-img-momang.jpg';
  }
  return "".concat(svs.core.config.data.svsconfig.cdn, "/images/casino-react/casino-game-card/").concat(image, "?breakCache=1");
};
const CasinoGameCard = _ref => {
  let gameName = _ref.gameName,
    isTall = _ref.isTall,
    containedHover = _ref.containedHover;
  const gameModel = svs.components.casino_react.ClientGamecache.getClientGamecache().games[gameName];
  const imageSource = isTall ? gameModel === null || gameModel === void 0 ? void 0 : gameModel.tallLobbyImage : gameModel === null || gameModel === void 0 ? void 0 : gameModel.lobbyImage;
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showQuickInfoModal = _useState2[0],
    setShowQuickInfoModal = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    imageLoaded = _useState4[0],
    setImageLoaded = _useState4[1];
  const _useLiveData = useLiveData(gameModel),
    liveData = _useLiveData.liveData,
    jackpotData = _useLiveData.jackpotData;
  const onImageLoaded = useCallback(() => {
    setImageLoaded(true);
  }, []);
  const onToggleQuickInfo = useCallback(() => {
    setShowQuickInfoModal(value => !value);
  }, []);
  const gameInfoPath = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(gameName);
  if (!gameModel) {
    return React.createElement(CasinoCardFallback, {
      title: gameName
    });
  }
  const name = gameModel.name,
    title = gameModel.title,
    badge = gameModel.badge,
    liveResultType = gameModel.liveResultType,
    liveCategory = gameModel.liveCategory;
  if (isSmallScreen) {
    return React.createElement(React.Fragment, null, React.createElement(CasinoCardWrapper, null, React.createElement("div", {
      style: {
        opacity: imageLoaded ? 1 : 0,
        transition: 'opacity 200ms'
      }
    }, React.createElement(Button, {
      className: "padding-0",
      "data-name": name,
      "data-title": title,
      onClick: onToggleQuickInfo,
      title: "L\xE4s mer om ".concat(title)
    }, React.createElement(React.Fragment, null, React.createElement(CasinoGameCardBadge, {
      badge: badge,
      jackpotData: jackpotData
    }), React.createElement(ImageMemoized, {
      fallbackImage: getFallbackImage(),
      image: imageSource,
      onLoadCallback: onImageLoaded
    }), React.createElement(CasinoGameRouletteBalls, {
      liveCategory: liveCategory,
      liveData: liveData,
      liveResultType: liveResultType
    }), React.createElement(CasinoGameBottomInformation, {
      gameModel: gameModel,
      liveData: liveData
    }))))), showQuickInfoModal && React.createElement(CasinoQuickInfo, {
      gameModel: gameModel,
      imageSource: imageSource,
      showQuickInfoModal: showQuickInfoModal,
      toggleQuickInfo: onToggleQuickInfo
    }));
  }
  return React.createElement("div", {
    className: "casino-game-card-wrapper"
  }, React.createElement(CasinoCardWrapper, null, React.createElement("div", {
    style: {
      opacity: imageLoaded ? 1 : 0,
      transition: 'opacity 200ms'
    }
  }, React.createElement("a", {
    "data-name": name,
    "data-title": title,
    href: gameInfoPath,
    rel: "follow",
    title: "L\xE4s mer om ".concat(title)
  }, React.createElement(CasinoGameCardBadge, {
    badge: badge,
    jackpotData: jackpotData
  }), React.createElement(ImageMemoized, {
    fallbackImage: getFallbackImage(),
    image: imageSource,
    onLoadCallback: onImageLoaded
  }), React.createElement(CasinoGameRouletteBalls, {
    liveCategory: liveCategory,
    liveData: liveData,
    liveResultType: liveResultType
  }), React.createElement(CasinoGameBottomInformation, {
    gameModel: gameModel,
    liveData: liveData
  })))), !containedHover && React.createElement(Card, {
    className: "casino-game-card-hover-content"
  }, React.createElement(React.Fragment, null, React.createElement(CasinoGameCardBadge, {
    badge: badge,
    jackpotData: jackpotData
  }), React.createElement(CasinoGamePreview, {
    gameModel: gameModel,
    imageSource: imageSource
  }))), containedHover && React.createElement("div", {
    className: "casino-game-card-hover-content--contained"
  }, React.createElement(CasinoGamePreviewSimple, {
    gameModel: gameModel
  })));
};
setGlobal('svs.components.casino_react.casinoGameCard.CasinoGameCard', React.memo(CasinoGameCard));

 })(window);